import { Modal } from '@maxtropy/components';
import React, { FC } from 'react';
import styles from './index.module.scss';
import { useRequest } from 'ahooks';
import { apiV2ElectricMapDataDemandPost } from '@maxtropy/device-customer-apis-v2';
import { Spin } from 'antd';
import { isNil } from 'lodash-es';
import { formatPercentWithoutSign, keepTwoOrLine } from '@/utils/utils';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

export interface IDemandStatisticsModal {
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  modalOpen: boolean;
}

const DemandStatisticsModal: FC<IDemandStatisticsModal> = props => {
  const { setModalOpen, modalOpen } = props;

  const { data: list, loading: listLoading } = useRequest(
    async () => {
      const res = await apiV2ElectricMapDataDemandPost({});
      return res.list;
    },
    {
      refreshDeps: [modalOpen],
      ready: modalOpen,
    }
  );

  return (
    <Modal
      open={modalOpen}
      title="需量统计"
      footer={null}
      getContainer={() => document.getElementById('full_screen_box') ?? document.body}
      onCancel={() => {
        setModalOpen(false);
      }}
      size="big"
    >
      <div className={styles.modal_wrapper} style={{ overflowX: (list ?? []).length > 3 ? 'auto' : 'hidden' }}>
        <Spin spinning={listLoading}>
          {(list ?? []).map(item => (
            <div className={styles.item_wrapper} key={item.name}>
              <div className={styles.name}>{item?.name ?? '--'}</div>
              <div className={styles.line}></div>
              <div className={styles.content}>
                <div className={styles.label}>本月最大需量</div>
                <div className={styles.value}>{keepTwoOrLine(item.value)}kW</div>
                <div className={styles.itemCompare}>
                  <span>环比</span>
                  <span style={{ color: !isNil(item?.rate) ? (item?.rate! > 0 ? '#FF4D4F' : '#59D744') : '#FFF' }}>
                    {formatPercentWithoutSign(item?.rate)}%
                  </span>
                  <span>
                    {!isNil(item?.rate) ? (
                      item?.rate! > 0 ? (
                        <ArrowUpOutlined style={{ color: '#FF4D4F' }} />
                      ) : (
                        <ArrowDownOutlined style={{ color: '#59D744' }} />
                      )
                    ) : null}
                  </span>
                </div>
              </div>
              <div className={styles.time_wrapper}>
                <div>发生时间</div>
                <div>{item.ts ? dayjs(item.ts).format('YYYY-MM-DD HH:mm:ss') : '--'}</div>
              </div>
            </div>
          ))}
        </Spin>
      </div>
    </Modal>
  );
};

export default DemandStatisticsModal;
